var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.354 14.648-.001-.001-2.72-2.697a6.85 6.85 0 1 0-1.183 1.184l2.697 2.697a.85.85 0 0 0 1.207 0v-.002a.85.85 0 0 0 0-1.18ZM7.25 12.9a5.15 5.15 0 1 1 0-10.3 5.15 5.15 0 0 1 0 10.3Z"
})));

export default SvgSearch;